import React from "react";
import styled from "styled-components";
/* import BindeleddetStandardLogo from "../BindeleddetLogoComponents/BindeleddetStandardLogo/BindeleddetStandardLogo"; */
import BindeleddetLogoBlue from "assets/images/bindeleddetLogo/BL_logo_standard.png";
import BindeleddetLogoWhite from "assets/images/bindeleddetLogo/BL_logo_standard_white.png";
import { Link, useLocation } from "react-router-dom";
import Burger from "./Burger";

export const NAVBAR_HEIGHT = 65;

const Nav = styled.nav<{ pathname: string }>`
  width: 100%;
  height: ${NAVBAR_HEIGHT}px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => (props.pathname === "/" ? "transparent" : "var(--neutral)")};
  position: ${props => (props.pathname === "/" ? "absolute" : "fixed")};
  top: 0;
  box-shadow: ${props => (props.pathname === "/" ? "" : "0 2px 4px 0 rgba(0, 0, 0, 0.2)")};
  z-index: 140;
`;
/* const StyledBindeleddetStandardLogo = styled(BindeleddetStandardLogo)`
  height: 600px;
`;  */

const StyledImg = styled.img`
  display: block;
  height: 40px;

  @media only screen and (max-width: 768px) {
    height: 35px;
  }
  @media only screen and (max-width: 600px) {
    height: 30px;
  }
`;

const StyledImageWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    padding: 0px 0;
  }
  @media only screen and (max-width: 600px) {
    padding: 0px 0;
  }
`;

const Navbar = () => {
  const { pathname } = useLocation();
  return (
    <Nav pathname={pathname}>
      <StyledImageWrapper>
        {/* <StyledBindeleddetStandardLogo height="40px" /> */}
        <Link to="/">
          <StyledImg
            src={
              pathname === "/" || document.body.getAttribute("data-theme") === "dark"
                ? BindeleddetLogoWhite
                : BindeleddetLogoBlue
            }
            alt="BL standard logo"
          />
        </Link>
      </StyledImageWrapper>
      <Burger />
    </Nav>
  );
};

export default Navbar;
